module.exports = __webpack_public_path__ + "static/img/3.b44b7d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/zh/3.png
// module id = YIt2
// module chunks = 0